@let _users = this.users.value();
@if (_users != undefined) {
<div class="main-container">
    <div class="list-container">
        <button kendoButton (click)="this.refreshFromDB()" themeColor="primary">Refresh From DB</button>
        <kendo-grid [kendoGridBinding]="_users" class="kendo-grid-custom" [filterable]="true" [sortable]="true" [selectable]="true"
            [pageable]="true" [pageSize]="30" (selectionChange)="onSelectionChange($event)">
            <kendo-grid-column field="sub" title="id"></kendo-grid-column>
            <kendo-grid-column field="name" title="Name"></kendo-grid-column>
            <kendo-grid-column field="email" title="Email">
            </kendo-grid-column>
            <kendo-grid-column field="sub" title="" [width]="60" [filterable]="false">
                <ng-template kendoGridCellTemplate="" let-dataItem>
                    <button kendoButton [svgIcon]="trashIcon" (click)="this.removeUser(dataItem.sub)"></button>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>

    </div>
    <div>
        @if (selectedUser != undefined) {
            <user-rights [sub]="selectedUser"></user-rights>
        }
    </div>
</div>
}

